import type { RouteObject } from "react-router";

import { ElectionStatusPage } from "./components/ElectionStatusPage";

export const electionStatusRoutes: RouteObject[] = [
  {
    index: true,
    Component: ElectionStatusPage,
    handle: { roles: ["administrator", "coordinator_csb", "coordinator_gsb"] },
  },
];
